module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"th":{"pre_delivery_in_house.main_title":"ใบผลทดสอบโดรน","pre_delivery_in_house.number_title":"เลขที่เอกสาร: ","pre_delivery_in_house.service_number":"{serviceNumber}"}}')
  delete Component.options._Ctor
}
